import Grid from '@mui/material/Grid';
import { NavItem } from '@qpr/components/Expandable/nav-items-view-model';
import {
  GridSizesDefault,
  LandingPageGridProps
} from '@qpr/landing-page/components/LandingPageGrid';
import React from 'react';

const LandingPageGrid = ({ tenantSymbol = '', sections, sizes, card }: LandingPageGridProps) => {
  const Card = card;
  return (
    <Grid
      container
      spacing={7}
      alignContent="stretch"
      alignItems="stretch"
      direction="row"
      justifyContent="space-evenly"
      style={{ marginTop: '24%', width: '100%' }}
    >
      {sections &&
        // eslint-disable-next-line @typescript-eslint/no-shadow
        sections.map((card: NavItem) => (
          <Grid
            item
            key={`card${card._id}`}
            xs={(sizes && sizes.xs) || GridSizesDefault.xs}
            sm={(sizes && sizes.sm) || GridSizesDefault.sm}
            md={(sizes && sizes.md) || GridSizesDefault.md}
            lg={(sizes && sizes.lg) || GridSizesDefault.lg}
            xl={(sizes && sizes.xl) || GridSizesDefault.xl}
          >
            <Card
              data-testid={`card${card._id}`}
              name={card.title}
              link={card.link}
              image={typeof card.icon === 'string' ? card.icon : ''}
              enabled={card.enabled}
              tenant={tenantSymbol}
            />
          </Grid>
        ))}
    </Grid>
  );
};

export default LandingPageGrid;
